import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from "@/components/layout.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Index",
        meta: { title: "学费查询" },
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/index.vue"),
    },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  //404重定向登录页面
  if (to.matched.length === 0) {
    // window.location.href = "/lottery/manage/"
  }
  /*路由发生改变修改页面的title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})

export default router;
